export default "__VITE_ASSET__4969be31__"